export default "__VITE_ASSET__BjYAM0lF__"